import React from 'react';
import { Card, Table, Button, Badge, ButtonGroup } from 'react-bootstrap';
import {
    getEmployeeStatusColor,
    getEmployeeStatusDisplayName,
    getContractTypeDisplayName,
    getDepartmentDisplayName,
    formatTurkishDate
} from '../../services/api';

const EmployeeTable = ({
    filteredEmployees,
    handleDetailClick,
    handleEditClick,
    handleLeaveModalOpen,
    handleEmployeeLeaveListOpen,
    handleShowDeleteModal,
    handleShowDocumentsModal
}) => {
    return (
        <Card>
            <Card.Body className="p-0">
                <div className="table-responsive">
                    <Table hover className="mb-0">
                        <thead>
                            <tr>
                                <th style={{ width: '20%' }}>Ad Soyad</th>
                                <th style={{ width: '15%' }}>Pozisyon</th>
                                <th style={{ width: '12%' }}>Departman</th>
                                <th style={{ width: '12%' }}>Telefon</th>
                                <th style={{ width: '10%' }}>Durum</th>
                                <th style={{ width: '16%' }}>Sözleşme</th>
                                <th style={{ width: '15%' }}>İşlemler</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredEmployees.length > 0 ? (
                                filteredEmployees.map((employee) => (
                                    <tr key={employee._id}>
                                        <td>
                                            <div>
                                                {employee.personalInfo?.fullName}
                                                <br />
                                                <small className="text-muted">
                                                    TC: {employee.personalInfo?.tcNo}
                                                </small>
                                            </div>
                                        </td>
                                        <td>{employee.workInfo?.position}</td>
                                        <td>
                                            <Badge bg="secondary">
                                                {getDepartmentDisplayName(employee.workInfo?.department)}
                                            </Badge>
                                        </td>
                                        <td>{employee.personalInfo?.phone}</td>
                                        <td>
                                            <Badge bg={getEmployeeStatusColor(employee.workInfo?.workStatus)}>
                                                {getEmployeeStatusDisplayName(employee.workInfo?.workStatus)}
                                            </Badge>
                                        </td>
                                        <td>
                                            <div>
                                                {getContractTypeDisplayName(employee.workInfo?.contractType)}
                                                <br />
                                                {employee.workInfo?.contractEndDate && (
                                                    <small className="text-warning">
                                                        Bitiş: {formatTurkishDate(employee.workInfo.contractEndDate)}
                                                    </small>
                                                )}
                                            </div>
                                        </td>
                                        <td>
                                            <ButtonGroup size="sm">
                                                <Button variant="info" onClick={() => handleDetailClick(employee)} title="Görüntüle">
                                                    <strong>Gö</strong>
                                                </Button>
                                                <Button variant="warning" onClick={() => handleEditClick(employee)} title="Düzenle">
                                                    <strong>Dü</strong>
                                                </Button>
                                                <Button variant="success" onClick={() => handleLeaveModalOpen(employee)} title="İzin Ver">
                                                    <strong>İz</strong>
                                                </Button>
                                                <Button variant="primary" onClick={() => handleEmployeeLeaveListOpen(employee)} title="İzin Listesi">
                                                    <strong>İ.L.</strong>
                                                </Button>
                                                <Button variant="danger" onClick={() => handleShowDeleteModal(employee)} title="Sil">
                                                    <strong>Arşiv</strong>
                                                </Button>
                                            </ButtonGroup>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="7" className="text-center py-4">
                                        Personel bulunamadı
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </div>
            </Card.Body>
        </Card>
    );
};

export default EmployeeTable;